module.exports = __webpack_public_path__ + "static/media/9.8529f874.jpg";